export const REQUEST_DB_TABLES_CSV = 'action/evaluation/tables/get'
export const DOWNLOAD_DB_TABLES_CSV = 'action/evaluation/tables/download'
